import React from 'react';
import { ISearchResult } from './ICustomerService';
import SearchResultItem from './SearchResultItem';

export interface SearchResultProps {
  results: ISearchResult[];
}

const SearchResult = ({ results }: SearchResultProps) => {
  return (
    <ul className="customer-service-faq__search-results__list">
      {results.map((result) => (
        <SearchResultItem result={result} key={result.UrlName} />
      ))}
    </ul>
  );
};

export default SearchResult;